<template>
  <form class="text-center">
    <v-text-field
      v-model="formData.email"
      v-validate="'required|email'"
      :error-messages="errors.collect('email')"
      label="Email"
      data-vv-name="email"
      required
    ></v-text-field>
    <v-text-field
      ref="password"
      v-model="formData.password"
      v-validate="'required|min:6'"
      :error-messages="errors.collect('password')"
      label="Password"
      data-vv-name="password"
      required
      :append-icon="revealPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="revealPassword ? 'text' : 'password'"
      @click:append="revealPassword = !revealPassword"
    ></v-text-field>
    <v-text-field
      v-model="confirmPassword"
      v-validate="'required|min:6|confirmed:password'"
      :error-messages="errors.collect('confirmPassword')"
      label="Re-enter Password"
      data-vv-name="confirmPassword"
      required
      :append-icon="revealPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="revealPassword ? 'text' : 'password'"
      @click:append="revealPassword = !revealPassword"
    ></v-text-field>
    <div class="mt-5 mb-3">
      <v-btn depressed color="accent" @click="submit">Sign Up</v-btn>
    </div>
    <div>
      Already have an account?
      <router-link :to="loginRoute.to">{{ loginRoute.label }}</router-link>
    </div>
  </form>
</template>
<script>
import types from '@/store/types';

export default {
  name: 'register',
  $_veeValidate: {
    validator: 'new',
  },

  data: () => ({
    formData: {
      email: '',
      password: '',
    },
    revealPassword: false,
    confirmPassword: '',
    dictionary: {
      attributes: {
        confirmPassword: 'Re-enter Password',
      },
    },
  }),

  computed: {
    loginRoute() {
      return this.$store.state.routes.LOGIN;
    },
  },

  mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch(types.SIGNUP_WITH_CREDS, this.formData)
            .then(() => {
              this.$router.push(this.loginRoute.to);
            });
        }
      });
    },
    clear() {
      this.$validator.reset();
    },
  },
};
</script>
